import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { Endpoints } from 'src/environments/endpoints';
import {
  ISearchCarColor,
  ISelectedCar,
} from '../pages/buro/interfaces/ISearchCar';
import { ConsumeService } from './consume.service';
import { sendBodyModifiedBy } from '../utils/user.interceptor';

@Injectable({
  providedIn: 'root',
})
export class CarManagerService {
  constructor(private consume: ConsumeService) {}

  searchCar(body: ISearchCarColor) {
    return this.consume.httpPost(
      `${Endpoints.carManager.base}/search-car`,
      body,
      null,
      sendBodyModifiedBy()
    );
  }

  getCars(idkeycloak: string, ticketBusqueda: string) {
    return this.consume
      .httpGet(
        `${Endpoints.carManager.base}/quoter/select?idkeycloak=${idkeycloak}&ticketBusqueda=${ticketBusqueda}`
      )
      .pipe(map((resp: any) => resp.data));
  }

  sendCarSelected(body: ISelectedCar) {
    return this.consume.httpPost(
      `${Endpoints.carManager.base}/advance-payment`,
      body,
      null,
      sendBodyModifiedBy()
    );
  }

  createPayPdf(body: ISelectedCar) {
    return this.consume.httpPost(
      `${Endpoints.carManagerV2.base}/advance-payment/pdf`,
      body
    );
  }

  createInitialPayPdf(body: any) {
    return this.consume.httpPost(
      `${Endpoints.carManagerV2.base}/initial-payment/pdf`,
      body
    );
  }
}
